import { useController } from "react-hook-form";
import { ORIGIN_COUNTRIES } from "../../../../../data/countries";
import { InvoiceRowSummary } from "./InvoiceRowSummary";
import { Select } from "./Select";
import { Input } from "./Input";
import { HiOutlineExclamationCircle } from "react-icons/hi";

export function CustomsInvoiceRowForm({ watch, control, index, remove }) {
  const unitPrice = watch(`invoice[${index}].unitPrice`);
  const quantity = watch(`invoice[${index}].quantity`);
  const invoiceCurrency = watch("invoiceCurrency");

  const totalPrice =
    unitPrice && quantity
      ? (parseFloat(unitPrice) * parseInt(quantity)).toFixed(2)
      : "0.00";

  const isFirstIndex = index === 0;

  const {
    field: descriptionField,
    fieldState: { error: descriptionErr },
  } = useController({
    name: `invoice[${index}].description`,
    control,
  });

  const {
    field: hsCodeField,
    fieldState: { error: hsCodeErr },
  } = useController({
    name: `invoice[${index}].hsCode`,
    control,
  });

  const {
    field: originCountryField,
    fieldState: { error: originCountryErr },
  } = useController({
    name: `invoice[${index}].originCountry`,
    control,
  });

  const {
    field: unitPriceField,
    fieldState: { error: unitPriceErr },
  } = useController({
    name: `invoice[${index}].unitPrice`,
    control,
  });

  const {
    field: quantityField,
    fieldState: { error: quantityErr },
  } = useController({
    name: `invoice[${index}].quantity`,
    control,
  });

  /** Build a single human-readable error sentence */
  const errorMessages = [
    descriptionErr?.message,
    hsCodeErr?.message,
    originCountryErr?.message,
    unitPriceErr?.message,
    quantityErr?.message,
  ].filter(Boolean);

  const rowErrorText =
    errorMessages.length > 0
      ? `Please fix the following: ${errorMessages.join(", ")}.`
      : null;

  return (
    <div className="space-y-3">
      {/* Main row */}
      <div className="grid grid-cols-1 sm:grid-cols-24 border rounded-md">
        <div className="col-span-8">
          <Input
            placeholder="e.g. brown leather bag"
            className="rounded-l-md"
            field={descriptionField}
            error={descriptionErr}
            testId={`invoice-description-${index}`}
          />
        </div>

        <div className="col-span-6">
          <Input
            placeholder="10-digit HS / HTS code"
            field={hsCodeField}
            error={hsCodeErr}
            testId={`invoice-hsCode-${index}`}
          />
        </div>

        <div className="col-span-4">
          <Select
            field={originCountryField}
            options={ORIGIN_COUNTRIES}
            error={originCountryErr}
            testId={`invoice-origin-country-${index}`}
          />
        </div>

        <div className="col-span-2">
          <Input
            placeholder="0.00"
            field={unitPriceField}
            isNumber
            error={unitPriceErr}
            testId={`invoice-unitPrice-${index}`}
          />
        </div>

        <div className="col-span-1">
          <Input
            placeholder="0"
            field={quantityField}
            isNumber
            error={quantityErr}
            testId={`invoice-quantity-${index}`}
          />
        </div>

        <div className="col-span-3">
          <InvoiceRowSummary
            total={totalPrice}
            currency={invoiceCurrency?.id}
            removeRow={() => remove(index)}
            isFirstIndex={isFirstIndex}
          />
        </div>
      </div>

      {rowErrorText && (
        <div className="mt-2 flex items-start gap-2 rounded-md bg-red-50 px-4 py-2 text-sm text-red-700">
          <HiOutlineExclamationCircle className="mt-[2px] h-4 w-4 shrink-0" />
          <p className="leading-snug">{rowErrorText}</p>
        </div>
      )}
    </div>
  );
}
